export default "__VITE_ASSET__U81Jp4kU__"